<template>
    <div
        :class="getScrollTopClass"
        @click="scrollTop">
        <button class="scroll-top__btn">
            <z-icon
                name="arrows/caret-light"
                width="24"
                height="24" />
        </button>
    </div>
</template>

<script setup>
import Velocity from 'velocity-animate'
import { onBeforeUnmount, onMounted, ref, computed } from 'vue'

const isVisible = ref(false)
const getScrollTopClass = computed(() => {
    return ['scroll-top', { 'scroll-top--hidden': !isVisible.value }]
})

const scrollTop = () => {
    Velocity(document.body, 'scroll', { offset: 0 })
}
const hideBtn = () => {
    isVisible.value = false
}
const setState = (direction, curScroll) => {
    if (curScroll < 500) {
        hideBtn()
    } else {
        isVisible.value = direction !== 1
    }
}
const checkScroll = () => {
    const doc = document.documentElement

    let prevScroll = window.scrollY || doc.scrollTop
    let curScroll
    let direction = 0
    let prevDirection = 0

    const checkScroll = () => {
        // Find the direction of scroll
        // 0 - initial, 1 - up, 2 - down
        curScroll = window.scrollY || doc.scrollTop

        if (curScroll > prevScroll) {
            // scrolled up
            direction = 2
        } else if (curScroll < prevScroll) {
            // scrolled down
            direction = 1
        }

        if (direction !== prevDirection) {
            setState(direction, curScroll)
        }

        prevScroll = curScroll
    }

    window.addEventListener('scroll', checkScroll)
}

onMounted(() => {
    checkScroll()
})
onBeforeUnmount(() => {
    window.removeEventListener('scroll', 'checkScroll')
})
</script>

<style lang="scss">
.scroll-top {
    $parent: &;

    margin-left: auto;
    // margin-bottom: -170px;
    // position: sticky;
    // bottom: 3%;
    position: fixed;
    bottom: 15%;
    right: 0;
    z-index: 99;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    gap: 8px;
    opacity: 1;
    transition: opacity 0.25s ease-out;
    color: var(--color-white);
    cursor: pointer;
    margin-right: $token-grids-desktop-offset;

    @include breakpoint(laptop) {
        margin-right: $token-grids-laptop-offset;
        // margin-bottom: -150px;
    }

    @include breakpoint(tablet) {
        margin-right: $token-grids-tablet-offset;
        // margin-bottom: -130px;
    }

    @include breakpoint(v-tablet) {
        margin-right: $token-grids-v-tablet-offset;
    }

    @include breakpoint(mobile) {
        // margin-bottom: -90px;
        margin-right: $token-grids-mobile-offset;
    }

    &:hover {
        #{$parent}__btn {
            background-color: var(--color-primary);
            border-color: var(--color-white);

            .z-icon path {
                fill: var(--color-white);
            }
        }
    }

    &__text {
        @include typo-level(M);
        font-weight: 500 !important;
        line-height: 110% !important;
        letter-spacing: -0.2px;

        @include breakpoint(mobile) {
            @include typo-level(XS);
        }
    }

    &__btn {
        width: 72px;
        height: 72px;
        border: none;
        border-radius: 50%;
        padding: 0;
        position: relative;
        cursor: pointer;
        outline: none;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--color-white);
        overflow: hidden;
        border: 1px solid var(--color-primary);
        backdrop-filter: blur(20px);
        transition: opacity 0.25s ease-out, background-color 0.25s ease-out,
            border-color 0.25s ease-out;

        @include breakpoint(laptop) {
            height: 64px;
            width: 64px;
        }

        @include breakpoint(mobile) {
            width: 40px;
            height: 40px;
        }

        .z-icon {
            position: absolute;

            path {
                fill: var(--color-primary);
                transition: fill 0.25s ease-out;
            }
        }
    }

    &__btn-svg {
        fill: rgba(255, 255, 255, 0.1);
        box-shadow: 4.8px -4.8px 4.8px 0px rgba(194, 194, 194, 0.1) inset,
            -4.8px 4.8px 4.8px 0px rgba(255, 255, 255, 0.1) inset;
        backdrop-filter: blur(4.800000190734863px);
    }

    &--hidden {
        opacity: 0;
        pointer-events: none;
    }
}
</style>
